import { render, staticRenderFns } from "./selectData.vue?vue&type=template&id=0bdd82b1&"
import script from "./selectData.vue?vue&type=script&lang=js&"
export * from "./selectData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports